let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bDgdd")).then(() => parcelRequire('ih9mF'));